

















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Company as ICompany } from "@/api/models/company";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";

@Component({
  components: { CustomTableCol, CustomTableItem, CustomTable }
})
export default class companyListsFormItem extends Vue {
  @Prop() item?: ICompany;
  @Prop() index!: number;
  isActive?: boolean = true;

  checkStatus() {
    this.isActive = !!this.item?.enabled;
  }
}
